export default ['DKK', 'EUR', 'GBP', 'NOK', 'SEK', 'USD']
